<template>
  <!--<el-transfer v-model="chooseItem" :data="transferData"></el-transfer>-->
  <div class="flexStartBox">
    <el-transfer
      filterable
      class="el_transfer"
      :filter-method="searchFilter"
      filter-placeholder="可根据人员学工号或姓名查询"
      :titles="['人员列表', '签到人员']"
      :modifyTransfer="modifyTransfer"
      v-model="chooseItem"
      :data="transferData">
    </el-transfer>
    <!--<button-upload :autoUpload=false :cathUrl="uploadUrl" :uploadSignPerson="uploadSignPerson" style="margin-left: 30px;"/>-->
  </div>
</template>

<script>
import {api} from '../../view/api/access-ctrl'
import {errorHandler} from '../../utils/errorHandler'
import ButtonUpload from './buttons/button-upload'
// import {httpUrl} from '../../mutual/http_url'
// import {getSchoolName} from '../../util/bus'

export default {
  components: {ButtonUpload},
  name: 'transfer',
  props: {
    uploadSignPerson: Boolean,
    modifyTransfer: {
      type: Array,
      default () {
        return []
      }
    },
  },
  data () {
    return {
      school: '',
      searchKey: '',
      chooseItem: [],
      transferData: [],
      // uploadUrl: '',
      keyStr: ''
    }
  },
  // created () {
  //   this.uploadUrl = `${httpUrl.test}${getSchoolName()}/meeting/importMeetingPlayers`
  // },
  mounted () {
    setTimeout(() => {
      this.school = window.sessionStorage.getItem('schoolName')
      api.getBasePersonList(this.searchKey)
        .then(list => {
          let listArr = []
          if (this.modifyTransfer) {
            this.modifyTransfer.map(v => {
              let checkObj = {
                key: '',
                label: '',
              }
              checkObj.key = v.code + '&*&' + v.name + '&*&' + v.departmentName
              checkObj.label = `${v.name} / ${v.code}`
              this.keyStr += '$$' + checkObj.key
              listArr.push(checkObj)
              this.chooseItem.push(checkObj.key)
            })
          }
          list.map(v => {
            let innerStates = false
            let obj = {
              key: '',
              label: '',
            }
            obj.key = v.code + '&*&' + v.name + '&*&' + v.departmentName
            obj.label = `${v.name} / ${v.code}`
            if (this.keyStr.indexOf(obj.key) !== -1) {
              innerStates = true
            }
            if (!innerStates) {
              listArr.push(obj)
            }
            this.keyStr += '$$' + obj.key
          })
          listArr.map(v => {
            this.transferData.unshift(v)
          })
        })
        .catch(errorHandler('查询失败'))
    }, 300)
  },
  methods: {
    getTransferData () {
      api.getBasePersonList(this.searchKey)
        .then(list => {
          let listArr = []
          list.map(v => {
            let innerStates = false
            let obj = {
              key: '',
              label: '',
            }
            obj.key = v.code + '&*&' + v.name + '&*&' + v.departmentName
            obj.label = `${v.name} / ${v.code}`
            if (this.keyStr.indexOf(obj.key) !== -1) {
              innerStates = true
            }
            if (!innerStates) {
              listArr.push(obj)
            }
            this.keyStr += '$$' + obj.key
          })
          listArr.map(v => {
            this.transferData.unshift(v)
          })
        })
        .catch(errorHandler('查询失败'))
    },
    searchFilter (query, item) {
      if (query || !item) {
        this.searchKey = query
      }
      return true
    }
  },
  watch: {
    searchKey () {
      this.getTransferData()
    },
    chooseItem (val) {
      if (val.length === this.transferData.length) {
        let rnd = Math.floor(Math.random() * 1000)
        this.getTransferData(rnd)
        this.searchKey = rnd
      }
      let newArr = []
      val.map(v => {
        let obj = {
          code: '',
          name: '',
          departmentName: ''
        }
        obj.code = v.split('&*&')[0]
        obj.name = v.split('&*&')[1]
        obj.departmentName = v.split('&*&')[2]
        newArr.push(obj)
      })
      this.$emit('changeMeetingPlayers', newArr)
    }
  }
}
</script>

<style lang="less" scoped>
  .el-transfer-panel {
    width: 300px;
  }
  .flexStartBox {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/transfer.vue